import "../../css/UserPageStyle/profile.css"

function ProfileBodyRight(props) {
    return (
        <div className="profile-body-right">
            {props.children}
        </div>
    )
}

export default ProfileBodyRight;


